import Icon from '@/components/ui/AppIcon';
import {FaFacebookF,FaAmazon,FaInstagram,FaPinterestP,FaEbay,} from 'react-icons/fa';

export default function SocialLinks({ platforms }) {
  const defaultPlatforms = [
    { name: 'eBay', url: 'https://www.ebay.com' },
    { name: 'Facebook', url: 'https://www.facebook.com' },
    { name: 'Amazon', url: 'https://www.amazon.com' },
    { name: 'Instagram', url: 'https://www.instagram.com' },
  ];

  const finalPlatforms =
    Array.isArray(platforms) && platforms.length > 0 ? platforms : defaultPlatforms;

  const getIconComponent = (name) => {
  const key = name.toLowerCase();

  if (key.includes('facebook')) return <FaFacebookF size={22} />;
  if (key.includes('amazon')) return <FaAmazon />;
  if (key.includes('instagram')) return <FaInstagram />;
  if (key.includes('pinterest')) return <FaPinterestP size={22} />;
  if (key.includes('ebay')) return <FaEbay size={30}/>;

  return <FaAmazon />; // fallback
};
  return (
    <div className="w-full mt-6">
      <div className="text-center mb-4">
        <p className="text-sm text-muted-foreground caption">Connect with us on</p>
      </div>

      <div className="flex items-center justify-center gap-3 md:gap-4 flex-wrap">
        {finalPlatforms.map((platform) => (
          <a
            key={platform?.name}
            href={platform?.url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-card border border-border rounded-xl hover:bg-muted transition-smooth"
            aria-label={`Visit our ${platform?.name} page`}
            title={platform?.name}
          >
            {/* <Icon
              name={getIconName(platform?.name)}
              variant="outline"
              size={24}
              className="text-foreground"
            /> */}
            <span classname= "text-xl text-primary">
              {getIconComponent(platform?.name)}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}